<template>
    <keep-alive>
        <component :is="loadPages" :data="currentComponent"></component>
    </keep-alive>
</template>


<script>
    // import "primevue/resources/themes/lara-light-teal/theme.css";
    // import "primevue/resources/primevue.min.css";
    // import "primeicons/primeicons.css";

    // import "@/assets/css/root.css";
    // import "@/assets/css/style.css";

    import { computed, defineAsyncComponent } from "vue";

    // import { useStore } from "@/store";
    // import { useRouter } from "vue-router";

    import { G } from "@/_common";

    import Navbar from "@/components/navbar/Navbar";
    import SidebarMenu from "@/components/sidebar/SidebarMenu";
    import Footer from "@/components/footer/Footer";
    import FooterSimple from "@/components/footer/FooterSimple";

    import Modal from "@/components/modal/Modal";


    export default {
        name: 'EmptyL',
        components: {
            Navbar,
            SidebarMenu,
            MainFooter: Footer,
            Footer: FooterSimple,
            Modal,
        },
        props: {
            data: {
                type: Object,
            },
        },
        setup(props) {
            // const store = useStore();
            // const router = useRouter();

            const gpage = G.current;

            gpage.page = props.data
                ? props.data.page || G.defaultPage
                : G.defaultPage;
            gpage.data[gpage.page] = props.data ? props.data.data || "" : "";

            // onMounted(async () => {
            //     // await ajax({ token: G.getClientData("DA_AUTH_TOKEN") })
            //     //     .get(store.getAccessRoles())
            //     //     .then((e) => {
            //     //         if (e && e.data)
            //     //             G.access_roles.value = e.data.roles.split(",");
            //     //     });
            // });

            // const setComponent = (val) => {
            //     gpage.page = val;
            //     gpage.data[gpage.page] = {};

            //     router.push({ name: val });
            // };

            const currentComponent = computed(() => {
                return gpage.data[gpage.page] || {};
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`).then(
                        (mod) => {
                            return mod;
                        },
                        () => {
                            return import('@/system_modules/NotFound');
                        }
                    ),
                    loadingComponent:
                        '<center><i class="fa fa-sync fa-spin"></i></center>',
                    // errorComponent: import("@/system_modules/NotFound")
                    errorComponent:
                        defineAsyncComponent(() =>
                            import('@/system_modules/NotFound')
                        ),
                    // timeout: 3000,
                    // suspensible: false,
                });
            });

            return { currentComponent, loadPages };
        },
    };
</script>


<style lang="scss">
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
    }
    .main-content {
        width: calc(100% - 280px);
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }
</style>
